module.exports = __webpack_public_path__ + "img/lsIcon.54545ea1.png";